export const BASE_URL = process.env.REACT_APP_API_URL;

// localStorage key for the selected UI language (also the i18next-detector default).
export const LANGUAGE_STORAGE_KEY = "i18nextLng";

// Mirrors the backend's StandardResultsSetPagination.max_page_size — lets
// "whole-list" fetchers (pickers, selectors) pull every row in one request
// instead of just the first page of 20.
export const MAX_PAGE_SIZE = 1000;
